import AnimatedPage from "../../animations/AnimatedPage";
import classes from "../profile/profile.module.css"
import defaultAvatar from "../../images/usericon.png"
import {useAuth} from "../../context/AuthContext";
import {useState} from "react";
import UploadFileDialog from "../../components/forms/UploadFileDialog";
import {updateProfileAvatar} from "../../clients/UserApiClient";
import {getProfile} from "../../clients/AuthApiClient";
import sendSuccessAlert from "../../services/alertService";


const Profile = () => {

    const [photo, setPhoto] = useState(null);
    const {profile, setProfile, avatar, setAvatar} = useAuth();
    const [redactedPhoto, setRedactedPhoto] = useState(false);

    function close() {
        setRedactedPhoto(false);
    }

    function open() {
        setRedactedPhoto(true);
    }

    async function handleSubmit() {
        await updateProfileAvatar(photo)
        const pr = await  getProfile();
        setProfile(pr.data);
        setAvatar(pr.data.avatar_url);
        sendSuccessAlert('Фото профиля успешно обновлено')
        setRedactedPhoto(false);
    }

    return (
        <AnimatedPage>
            <UploadFileDialog
                text={'Прикрепите фото'}
                accept={'image/*,/img/*'}
                isOpen={redactedPhoto}
                onClose={close}
                onSubmit={handleSubmit}
                onChange={el => setPhoto(el.target.files[0])}
            />
            <div className={classes.profileContainer}>
                <h3>Ваш профиль</h3>
                <div className={classes.avatarWrapper}>
                    <div className={classes.avatarHover}>
                        <img
                            src={avatar || defaultAvatar}
                            alt="user avatar"
                            className={classes.avatar}
                        />
                        <div className={classes.overlay} onClick={open}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <g stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
                                   fill="none">
                                    <path
                                        d="M3 7.5h3l1.5-2h8L18 7.5h3a1 1 0 0 1 1 1V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.5a1 1 0 0 1 1-1z"/>
                                    <circle cx="12" cy="13.5" r="3.5"/>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className={classes.info}>
                    <h2 className={classes.username}><b></b>{profile.username}</h2>
                    <p className={classes.name}>{profile.first_name} {profile.last_name}</p>
                    <p className={classes.email}>{profile.email}</p>
                </div>
            </div>
        </AnimatedPage>
    )
}

export default Profile;